import {UserModel} from '../../shared/services/user/user.model';
import {PaymentDetailModel} from '../../shared/models/payment/paymentDetail.model';

export class OpenModalAccountSettings {
  static readonly type = '[modal] open account modal';
}

export class OpenModalPaycardDetail {
  static readonly type = '[modal] open paycard detail modal';
  constructor(public paycardId: string) {}
}

export class OpenModalPreorderDetail {
  static readonly type = '[modal] open preorder detail modal';
  constructor(public reference: string) {}
}

export class OpenModalWebchargeDetail {
  static readonly type = '[modal] open webcharge detail modal';
  constructor(public reference: string) {}
}

export class OpenModalPaymentDetail {
  static readonly type = '[modal] open payment detail modal';
  constructor(public payment: PaymentDetailModel) {}
}

export class OpenModalUserEdit {
  static readonly type = '[modal] open user edit modal';
  constructor(public user: UserModel) {}
}

export class OpenModalUserDelete {
  static readonly type = '[modal] open user delete modal';
  constructor(public userName: string) {}
}

export class OpenModalUserCreate {
  static readonly type = '[modal] open user create modal';
}
